// @flow
import React, { useEffect } from 'react'
import {
  ButtonPrimary,
  PaymentCardList,
} from 'src/common/components'

import { getDefaultPaymentMethod } from 'src/helpers/paymentHelper'

import type { PaymentsState, CreditCardType, ACHMethod } from 'src/redux/reducers/payments'

type CardPropsType = {
    setPaymentCardMethod: (data: ?CreditCardType | ACHMethod) => void,
    setPaymentPayload: (data: {
        payload: any,
        order_id: string
    }) => void,
    payments: PaymentsState,
    paymentCard: ?CreditCardType,
    buttonText: ?string,
    addButtonText: string,
    deletePaymentMethod: () => void,
    editable: boolean,
    canAddCard: boolean,
    onSubmitCardPayment: () => void
};

const CardPayment = (props: CardPropsType) => {
  const {
    payments: { paymentMethods, paymentToken },
    paymentCard,
    setPaymentCardMethod,
    onSubmitCardPayment,
    canAddCard,
    editable,
    deletePaymentMethod,
    buttonText,
    addButtonText,
  } = props

  useEffect(() => {
    setPaymentCardMethod(getDefaultPaymentMethod(paymentMethods?.cards) || paymentMethods?.cards?.[0])
  }, [paymentMethods?.cards?.length])

  return (
    <>
      <PaymentCardList
        paymentMethods={paymentMethods}
        checked={paymentCard}
        setChecked={setPaymentCardMethod}
        verifiedOnly={true}
        buttonText={buttonText}
        paymentToken={paymentToken}
        editable={editable}
        onSubmit={onSubmitCardPayment}
        canAddCard={canAddCard}
        deletePaymentMethod={deletePaymentMethod}
        addButtonText={addButtonText}
      />
      {paymentCard && (
        <div className="d-flex justify-content-center">
          <ButtonPrimary
            disabled={!paymentCard}
            size="medium"
            buttonText="Submit payment"
            action={() => onSubmitCardPayment()}
          />
        </div>)}
    </>
  )
}

export default CardPayment
